<!--
  成长档案 - 详情
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <!--学年学期-->
    <div class="divPageHeaderBox">
      <ul class="ulTabsBox"></ul>
      <div class="divSemesterBox">
        <div class="divTitle">学期</div>
        <el-select
          v-model="data.SemesterId"
          placeholder="请选择"
          class="selForm width_300"
          @change="handSemesterChange"
        >
          <el-option
            v-for="item in optSemester"
            :key="item.semesterId"
            :label="item.name"
            :value="item.semesterId"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="pageBox">
      <el-row :gutter="20" class="mt-4">
        <!--参与活动-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 1 }"
            data-type="activity"
            @click="onBoxTabs(1)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_2">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-paper-plane-alt"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["Activity"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">组织活动</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 行为偏常 -->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 2 }"
            data-type="activity"
            @click="onBoxTabs(2)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_1">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-circle-warning-o"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["AbnormalBehavior"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">行为偏常辅导</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--活动计划-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 3 }"
            data-type="daily"
            @click="onBoxTabs(3)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_2">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-exam-o"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["ActivityPlan"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">活动计划</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--主题班会-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 4 }"
            data-type="award"
            @click="onBoxTabs(4)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_3">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-cube-users-alt"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["ClassMeeting"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">主题班会</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--班级安全教育-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 5 }"
            data-type="award"
            @click="onBoxTabs(5)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_3">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-jiaoyu"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["ClassWorkMemo"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">安全教育</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--家校联系记录-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 6 }"
            data-type="punishment"
            @click="onBoxTabs(6)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_6">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-phone-o"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["ContactRecord"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">家校联系</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 个别谈话 -->
        <el-col :xl="4" :sm="12" :md="8" :lg="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 7 }"
            data-type="punishment"
            @click="onBoxTabs(7)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_4">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-comments-alt"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["IndividualEducation"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">个别谈话</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 学期工作计划 -->
        <el-col :xl="4" :sm="12" :md="8" :lg="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 8 }"
            data-type="punishment"
            @click="onBoxTabs(8)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_1">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-file-user-o"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["WorkPlan"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">工作计划</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--工作总结-->
        <el-col :xl="4" :sm="12" :md="8" :lg="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 9 }"
            data-type="dorm"
            @click="onBoxTabs(9)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_4">
                    <svg class="icon font-size-42" aria-hidden="true">
                      <use xlink:href="#fax-evaluation"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["WorkSummary"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">工作总结</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 个人日常行为 -->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 10 }"
            data-type="punishment"
            @click="onBoxTabs(10)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_2">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-user-behavior"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["MoralityLog"] }}
                    <!-- {{regNullArray(itemClassCadre)?0:itemClassCadre.length}} -->
                    <span class="spUnit">次</span>
                  </div>
                  <div class="typeName">个人扣分</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--学生奖励-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 14 }"
            data-type="award"
            @click="onBoxTabs(14)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_3">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-medals-alt"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["Prize"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">学生奖励</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--处分记录-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 15 }"
            data-type="punishment"
            @click="onBoxTabs(15)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_6">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-file-punish"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["Punish"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">处分记录</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--处分撤销-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 16 }"
            data-type="punishment"
            @click="onBoxTabs(16)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_1">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-img-close"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["PunishRevoke"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">处分撤销</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--留宿管理-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 17 }"
            data-type="punishment"
            @click="onBoxTabs(17)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_2">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-stay-alt"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["DormStay"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">学生留宿</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!--停宿管理-->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 18 }"
            data-type="punishment"
            @click="onBoxTabs(18)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_2">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-building"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["DormSuspend"]
                    }}<span class="spUnit">次</span>
                  </div>
                  <div class="typeName">学生停宿</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 班主任评语 -->
        <el-col :xl="4" :sm="12" :lg="8" :md="8">
          <div
            class="card cardTypeLable"
            :class="{ cardTypeAct: currsorBoxIndex == 21 }"
            data-type="punishment"
            @click="onBoxTabs(21)"
          >
            <div class="card-body">
              <div class="typeLabelBox clearfix">
                <div class="leftBox VerticalMid">
                  <div class="iconBox VerticalMid labelColor_7">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-message-alt"></use>
                    </svg>
                  </div>
                </div>
                <div class="rightBox">
                  <div class="numberBox">
                    {{ regNull(itemData) ? 0 : itemData["StudentComment"]
                    }}<span class="spUnit">条</span>
                  </div>
                  <div class="typeName">品德评语</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!--参与活动-->
      <el-card class="box-card activity" v-show="currsorBoxIndex == 1">
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            参与活动
          </h3>
        </div>
        <div
          class="card-body listBox"
          v-if="itemActivity != null && itemActivity.length > 0"
        >
          <el-table
            :data="itemActivity"
            stripe
            class="elTableData"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
            ></el-table-column>
            <el-table-column label="活动名称">
              <template slot-scope="scope">
                <span
                  class="spLevel color-danger"
                  v-if="scope.row.level.indexOf('校') > -1"
                  >校</span
                >
                <span
                  class="spLevel color-warning"
                  v-else-if="scope.row.level.indexOf('部') > -1"
                  >部</span
                >
                <span
                  class="spLevel color-primary"
                  v-else-if="scope.row.level.indexOf('班') > -1"
                  >班</span
                >
                <span class="spLevel color-primary" v-else>{{
                  scope.row.level
                }}</span>
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column label="附件">
              <template slot-scope="scope">
                <div class="imgListBox">
                  <a href="javascript:void(0);" class="aLink aLeftOperation">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-chevron-left"></use>
                    </svg>
                  </a>
                  <a href="javascript:void(0);" class="aLink aRightOperation">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-chevron-right"></use>
                    </svg>
                  </a>
                  <div class="imgContent">
                    <div
                      class="imgBox clearfix"
                      data-left="0"
                      style="margin-left: 0px"
                    >
                      <span
                        class="spImg"
                        v-for="(d, index) in scope.row.photoList"
                        :key="index"
                      >
                        <el-image
                          class="itemImg"
                          :src="d"
                          :preview-src-list="scope.row.photoList"
                        ></el-image>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="结束时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.endDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无参与活动
          </div>
        </div>
      </el-card>

      <!-- 行为偏常辅导 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 2"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            行为偏常辅导
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemAbnormal)">
          <el-table
            :data="itemAbnormal"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="studentNo" label="学号"></el-table-column>
            <el-table-column prop="studentName" label="姓名"></el-table-column>
            <el-table-column prop="class" label="班级"></el-table-column>
            <el-table-column label="主要偏常行为">
              <template slot-scope="scope">
                <div>{{ onDelHtml(scope.row.abnormalBehavior) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                {{ scope.row.createDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无行为偏常辅导
          </div>
        </div>
      </el-card>

      <!-- 活动计划 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 3"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            活动计划
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemActivityPlan)">
          <el-table
            :data="itemActivityPlan"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="class" label="班级"></el-table-column>
            <el-table-column prop="date" label="周"></el-table-column>
            <el-table-column label="内容">
              <template slot-scope="scope">
                <div>{{ onDelHtml(scope.row.content) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                {{ scope.row.createDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无活动计划
          </div>
        </div>
      </el-card>

      <!-- 主题班会 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 4"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            主题班会
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemMeeting)">
          <el-table
            :data="itemMeeting"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="class" label="班级"></el-table-column>
            <el-table-column label="课题">
              <template slot-scope="scope">
                <div>{{ onDelHtml(scope.row.topic) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="时间">
              <template slot-scope="scope">
                {{ "第" + scope.row.week + "周" }}{{ scope.row.dayOfWeek }}
              </template>
            </el-table-column>
            <el-table-column label="课节">
              <template slot-scope="scope">
                {{ "第" + scope.row.schedule + "节" }}
              </template>
            </el-table-column>
            <el-table-column label="节数">
              <template slot-scope="scope">
                {{ "共用" + scope.row.duration + "节" }}
              </template>
            </el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                {{ scope.row.createDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无主题班会
          </div>
        </div>
      </el-card>

      <!-- 安全教育 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 5"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            安全教育
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemWorkMemo)">
          <el-table
            :data="itemWorkMemo"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="class" label="班级"></el-table-column>
            <el-table-column prop="date" label="周"></el-table-column>
            <el-table-column label="内容">
              <template slot-scope="scope">
                <div>{{ onDelHtml(scope.row.content) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                {{ scope.row.createDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无安全教育
          </div>
        </div>
      </el-card>

      <!-- 家校联系 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 6"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            家校联系
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemContact)">
          <el-table
            :data="itemContact"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="studentNo" label="学号"></el-table-column>
            <el-table-column prop="studentName" label="姓名"></el-table-column>
            <el-table-column prop="class" label="班级"></el-table-column>
            <el-table-column
              prop="relationShip"
              label="联系对象"
            ></el-table-column>
            <el-table-column label="日期">
              <template slot-scope="scope">
                {{ scope.row.contactDate | dateformatDay }}
              </template>
            </el-table-column>
            <el-table-column
              prop="contactWay"
              label="联系方式"
            ></el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                {{ scope.row.createDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无家校联系
          </div>
        </div>
      </el-card>

      <!-- 个别谈话 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 7"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            个别谈话
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemIndividual)">
          <el-table
            :data="itemIndividual"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="studentNo" label="学号"></el-table-column>
            <el-table-column prop="studentName" label="姓名"></el-table-column>
            <el-table-column prop="class" label="班级"></el-table-column>
            <el-table-column label="谈话内容">
              <template slot-scope="scope">
                <div>{{ onDelHtml(scope.row.content) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="日期">
              <template slot-scope="scope">
                {{ scope.row.talkDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无个别谈话
          </div>
        </div>
      </el-card>

      <!-- 工作计划 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 8"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            工作计划
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemWorkPlan)">
          <el-table
            :data="itemWorkPlan"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="class" label="班级"></el-table-column>
            <el-table-column label="计划内容">
              <template slot-scope="scope">
                <div>{{ onDelHtml(scope.row.content) }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无工作计划
          </div>
        </div>
      </el-card>

      <!-- 工作总结 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 9"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            工作总结
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemWorkSummary)">
          <el-table
            :data="itemWorkSummary"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="class" label="班级"></el-table-column>
            <el-table-column label="总结内容">
              <template slot-scope="scope">
                <div>{{ onDelHtml(scope.row.content) }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            工作总结
          </div>
        </div>
      </el-card>

      <!-- 日常行为 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 10"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            日常行为
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemPersonLog)">
          <el-table
            :data="itemPersonLog"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="reason" label="原因"></el-table-column>
            <el-table-column
              prop="class"
              label="班级"
              width="140"
            ></el-table-column>
            <el-table-column
              prop="room"
              label="宿舍"
              width="140"
            ></el-table-column>
            <el-table-column
              prop="student"
              label="学生"
              width="140"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="行为时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.logDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无个人扣分
          </div>
        </div>
      </el-card>

      <!-- 学生奖励 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 14"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            学生奖励
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemPrize)">
          <el-table
            :data="itemPrize"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="name" label="奖项"></el-table-column>
            <el-table-column
              prop="member"
              label="学生"
              min-width="120"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div v-html="scope.row.member"></div>
              </template>
            </el-table-column>
            <el-table-column prop="score" label="奖励类型">
              <template slot-scope="scope">
                <span>{{ scope.row.type.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="score" label="奖励级别">
              <template slot-scope="scope">
                <span v-if="scope.row.level != null">{{
                  scope.row.level.name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="获奖时间">
              <template slot-scope="scope">
                {{ scope.row.prizeDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无学生奖励
          </div>
        </div>
      </el-card>

      <!-- 学生处分 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 15"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            学生处分
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemPunish)">
          <el-table
            :data="itemPunish"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="punishNo" label="处分号"></el-table-column>
            <el-table-column prop="reason" label="处分原因"></el-table-column>
            <el-table-column
              prop="member"
              label="学生"
              min-width="120"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div v-html="scope.row.member"></div>
              </template>
            </el-table-column>
            <el-table-column label="处分时间">
              <template slot-scope="scope">
                {{ scope.row.punishDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无学生处分
          </div>
        </div>
      </el-card>

      <!-- 处分撤销 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 16"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            处分撤销
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemPunishRevoke)">
          <el-table
            :data="itemPunishRevoke"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="studentNo" label="学号"></el-table-column>
            <el-table-column prop="studentName" label="姓名"></el-table-column>
            <el-table-column prop="className" label="班级"></el-table-column>
            <el-table-column label="撤销申请日期">
              <template slot-scope="scope">
                {{ scope.row.applyDate | dateformatDay }}
              </template>
            </el-table-column>
            <el-table-column label="撤销日期">
              <template slot-scope="scope">
                {{ scope.row.revokeDate | dateformatDay }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无处分撤销
          </div>
        </div>
      </el-card>

      <!-- 学生留宿 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 17"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            学生留宿
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemDormStay)">
          <el-table
            :data="itemDormStay"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="building" label="楼号"></el-table-column>
            <el-table-column prop="floor" label="楼层"></el-table-column>
            <el-table-column prop="room" label="房间"></el-table-column>
            <el-table-column prop="bed" label="床位"></el-table-column>
            <el-table-column prop="studentNo" label="学号"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column label="留宿开始时间">
              <template slot-scope="scope">
                {{ scope.row.startDate | dateformatMinute }}
              </template>
            </el-table-column>
            <el-table-column label="留宿结束时间">
              <template slot-scope="scope">
                {{ scope.row.endDate | dateformatMinute }}
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="联系电话"></el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无学生留宿
          </div>
        </div>
      </el-card>

      <!-- 学生停宿 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 18"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            学生停宿
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemDormSuspend)">
          <el-table
            :data="itemDormSuspend"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="building" label="楼号"></el-table-column>
            <el-table-column prop="floor" label="楼层"></el-table-column>
            <el-table-column prop="room" label="房间"></el-table-column>
            <el-table-column prop="bed" label="床位"></el-table-column>
            <el-table-column prop="studentNo" label="学号"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column label="停宿开始时间">
              <template slot-scope="scope">
                {{ scope.row.startDate | dateformatMinute }}
              </template>
            </el-table-column>
            <el-table-column label="停宿结束时间">
              <template slot-scope="scope">
                {{ scope.row.endDate | dateformatMinute }}
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="联系电话"></el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无学生停宿
          </div>
        </div>
      </el-card>

      <!-- 品德评语 -->
      <el-card
        class="box-card"
        v-if="currsorBoxIndex == 21"
        style="margin-top: 20px"
      >
        <div slot="header" class="card-header">
          <h3 class="card-title titleCont">
            <span class="spIcon"></span>
            品德评语
          </h3>
        </div>
        <div class="card-body p-0" v-if="!regNullArray(itemComment)">
          <el-table
            :data="itemComment"
            stripe
            style="width: 100%"
            :key="Math.random()"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="name" label="学生"></el-table-column>
            <el-table-column prop="class" label="班级"></el-table-column>
            <el-table-column prop="teacher" label="班主任"></el-table-column>
            <el-table-column
              prop="commentsRankString"
              label="等第"
            ></el-table-column>
          </el-table>
        </div>
        <div class="card-body p-4 text-center" v-else>
          <div class="NoDataTipCont">
            <svg aria-hidden="true" class="icon faxIcon color-warning">
              <use xlink:href="#fax-exclamation-triangle-alt"></use>
            </svg>
            暂无品德评语
          </div>
        </div>
      </el-card>
    </div>
    <!--
    <div class="pt-10">
      <el-button icon="el-icon-back" @click="onBack()">返回</el-button>
    </div> -->
  </div>
</template>

<script>
import "@/assets/css/Admin.css";
export default {
  components: {},
  data() {
    return {
      fullscreenLoading: false,
      studentId: null,
      random: 0, //刷新组件
      itemData: [],

      imageUrl: null,
      optSemester: [], //学期
      data: {
        SemesterId: null, //学期
      },
      // 数据类型
      currsorBoxIndex: 1,

      itemActivity: [], //活动数据
      itemAbnormal: [], //行为偏常数据
      itemActivityPlan: [], //活动计划数据
      itemMeeting: [], //主题班会
      itemWorkMemo: [], //安全教育
      itemContact: [], //家校联系
      itemIndividual: [], //个别谈话
      itemWorkPlan: [], //工作计划
      itemWorkSummary: [], //工作总结
      itemPersonLog: [], //个人扣分
      // itemDpLog: [], //个人扣分
      // itemClassLog: [], //班级扣分
      // itemDormitoryLog: [], //宿舍扣分
      itemPrize: [], //学生奖励
      itemPunish: [], //学生处分
      itemPunishRevoke: [], //处分撤销
      itemDormStay: [], //学生留宿
      itemDormSuspend: [], //学生停宿
      itemInterview: [], //班主任访谈
      itemRelation: [], //关联心导师
      itemComment: [], //品德评语
    };
  },
  filters: {
    flNoValue(obj) {
      if (obj == null || typeof obj == "undefined" || obj == "") {
        return "暂无数据";
      }
      return obj;
    },
    flScore(objItem) {
      let that = this;
      if (objItem != null && objItem != "") {
        return objItem;
      } else {
        return "-";
      }
    },
  },
  methods: {
    /**
     * @description 获取处分类型
     * @param {Object} objItem
     */
    onGetPunishesLevel(objItem) {
      let that = this;
      if (!regNullArray(objItem)) {
        let tpItem = objItem.find((item) => item.studentId == that.studentId);
        if (!regNull(tpItem)) {
          return tpItem.levelName;
        } else {
          return "-";
        }
      } else {
        return "-";
      }
    },
    onBoxTabs(_index) {
      this.currsorBoxIndex = _index;

      if (_index == 1) {
        SearchActivity(this);
      } else if (_index == 2) {
        SearchAbnormal(this);
      } else if (_index == 3) {
        SearchActivityPlan(this);
      } else if (_index == 4) {
        SearchMeeting(this);
      } else if (_index == 5) {
        SearchWorkMemo(this);
      } else if (_index == 6) {
        SearchContact(this);
      } else if (_index == 7) {
        SearchIndividual(this);
      } else if (_index == 8) {
        SearchWorkPlan(this);
      } else if (_index == 9) {
        SearchWorkSummary(this);
      } else if (_index == 10) {
        SearchPersonLog(this);
      } else if (_index == 14) {
        SearchPrize(this);
      } else if (_index == 15) {
        SearchPunish(this);
      } else if (_index == 16) {
        SearchPunishRevoke(this);
      } else if (_index == 17) {
        SearchDormStay(this);
      } else if (_index == 18) {
        SearchDormSuspend(this);
      } else if (_index == 21) {
        SearchComment(this);
      }
    },
    //选择学期
    handSemesterChange(val) {
      let that = this;
      that.data.SemesterId = val;
      //that.onTabClick();
      myWorkload(that);
      SearchActivity(that);
    },

    /**
     * //返回
     */
    onBack() {
      let that = this;
      back(that);
    },
    /**
     * @description 去除HTML和截取字符串，最多140个字符
     * @param {Object} _value
     */
    onDelHtml(_value) {
      let strFont = delHtml(_value);
      if (!regNull(strFont) && strFont.length > 140) {
        return strFont.substring(0, 140) + "...";
      } else {
        return strFont;
      }
    },
  },
  created() {
    let that = this;
    that.fullscreenLoading = true;
    ajaxGet(that, "/api/admin/semester", null, function (resSemester) {
      // //获取学期
      // that.fullscreenLoading = false;
      // that.optSemester = resSemester;
      // 学期
      if (!regNullArray(resSemester)) {
        let SemesterId = that.data.SemesterId;
        that.optSemester = resSemester;
        // 获得学期数据
        for (let item of resSemester) {
          // let arrTemp = {
          //   Title: item.name, //semester[item].name,
          //   Value: item.semesterId, //semester[item].semesterId,
          // };
          // 默认学期显示当前学期
          if (
            SemesterId == null ||
            typeof SemesterId == "undefined" ||
            SemesterId == ""
          ) {
            if (item.isCurrent == true) {
              //that.currentYear = item.semesterId;
              that.data.SemesterId = item.semesterId;
            }
          }
        }
        setTimeout(() => {
          myWorkload(that);
          SearchActivity(that);
        }, 100);
      }
    });
    //that.dataReset = JSON.parse(JSON.stringify(that.data));
  },
  mounted() {
    // 向左切图
    $(".listBox").on("click", ".aLeftOperation", function () {
      let imgTotal = $(this)
        .parent(".imgListBox")
        .find(".imgContent")
        .find(".spImg").length;
      let mLeftValue = calculationLeft(
        $(this)
          .parent(".imgListBox")
          .find(".imgContent")
          .find(".imgBox")
          .attr("data-left"),
        "LEFT",
        imgTotal
      );
      $(this)
        .parent(".imgListBox")
        .find(".imgContent")
        .find(".imgBox")
        .attr("data-left", mLeftValue);
      $(this)
        .parent(".imgListBox")
        .find(".imgContent")
        .find(".imgBox")
        .animate({
          "margin-left": mLeftValue + "px",
        });
    });
    // 向右切图
    $(".listBox").on("click", ".aRightOperation", function () {
      let imgTotal = $(this)
        .parent(".imgListBox")
        .find(".imgContent")
        .find(".spImg").length;
      let mLeftValue = calculationLeft(
        $(this)
          .parent(".imgListBox")
          .find(".imgContent")
          .find(".imgBox")
          .attr("data-left"),
        "RIGHT",
        imgTotal
      );
      $(this)
        .parent(".imgListBox")
        .find(".imgContent")
        .find(".imgBox")
        .attr("data-left", mLeftValue);
      $(this)
        .parent(".imgListBox")
        .find(".imgContent")
        .find(".imgBox")
        .animate({
          "margin-left": mLeftValue + "px",
        });
    });
    // 计算位置
    function calculationLeft(obj, type, total) {
      let intValue = parseInt(obj);
      if (type.toUpperCase() == "LEFT") {
        if (parseInt(total - 1) * 50 > intValue * -1) {
          intValue = intValue - 50;
        }
      } else {
        if (parseInt(intValue) != 0) {
          intValue = intValue + 50;
        }
      }
      return intValue;
    }
  },
};
//我的工作量
function myWorkload(that) {
  that.fullscreenLoading = true;
  ajaxGet(
    that,
    "/api/admin/workload/myworkload?semesterId=" + that.data.SemesterId,
    null,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemData = resData;
    }
  );
}

//活动记录
function SearchActivity(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/activitysearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      //that.itemActivityTotal = resData.items.length;
      for (var i in resData) {
        if (resData[i].attachment != null) {
          var list = resData[i].attachment.split("|");
          var it = [];
          for (var j in list) {
            it.push(that.onImgSpliceUrl(list[j]));
          }
          resData[i].photoList = it;
        }
        if (!regNullArray(resData[i].photo)) {
          var list = resData[i].photo.split("|");
          var it = [];
          for (var j in list) {
            it.push(that.$ServerUrl() + list[j]);
          }

          if (resData[i].photoList != null) {
            resData[i].photoList.push(...it);
          } else {
            resData[i].photoList = it;
          }
        }
      }
      that.itemActivity = resData;
    }
  );
}

//行为偏常
function SearchAbnormal(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/abnormalsearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemAbnormal = resData;
    }
  );
}

//活动计划
function SearchActivityPlan(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/activityplansearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemActivityPlan = resData;
    }
  );
}

//主题班会
function SearchMeeting(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(that, "/api/admin/workload/meetingsearch", param, function (resData) {
    that.fullscreenLoading = false;
    that.itemMeeting = resData;
  });
}

//安全教育
function SearchWorkMemo(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/workmemosearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemWorkMemo = resData;
    }
  );
}

//家校联系
function SearchContact(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(that, "/api/admin/workload/contactsearch", param, function (resData) {
    that.fullscreenLoading = false;
    that.itemContact = resData;
  });
}

//个别谈话
function SearchIndividual(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/individualsearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemIndividual = resData;
    }
  );
}

//工作计划
function SearchWorkPlan(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/workplansearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemWorkPlan = resData;
    }
  );
}

//工作总结
function SearchWorkSummary(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/worksummarysearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemWorkSummary = resData;
    }
  );
}

//个人扣分
function SearchPersonLog(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/personlogsearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;

      that.itemPersonLog = resData;
    }
  );
}

//学生奖励
function SearchPrize(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(that, "/api/admin/workload/prizesearch", param, function (resData) {
    that.fullscreenLoading = false;
    that.itemPrize = resData;

    for (var i in resData) {
      var it = resData[i];
      it.member = "";
      for (var j in it.members) {
        var member = it.members[j];
        var score = 0;
        for (var m in member.configs) {
          score += member.configs[m].score;
        }
        if (it.member == "") {
          it.member = member.student.name;
        } else {
          it.member += "、" + member.student.name;
        }
      }
    }
  });
}

//学生处分
function SearchPunish(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(that, "/api/admin/workload/punishsearch", param, function (resData) {
    that.fullscreenLoading = false;
    that.itemPunish = resData;
    console.log(resData);
    for (var it of resData) {
      //var it = resData[i];
      it.member = "";
      for (var j in it.members) {
        var member = it.members[j];
        it.member += member.name + "【" + member.level + "】、";
      }
      it.member = it.member.slice(0, it.member.length - 1);
    }
  });
}

//处分撤销
function SearchPunishRevoke(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/punishrevokesearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemPunishRevoke = resData;
    }
  );
}

//学生留宿
function SearchDormStay(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/dormstaysearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemDormStay = resData;
    }
  );
}

//学生停宿
function SearchDormSuspend(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/dormsuspendsearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemDormSuspend = resData;
    }
  );
}

//班主任访谈
function SearchInterview(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/interviewsearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemInterview = resData;
    }
  );
}

//关联心导师
function SearchRelation(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(
    that,
    "/api/admin/workload/relationsearch",
    param,
    function (resData) {
      that.fullscreenLoading = false;
      that.itemRelation = resData;
    }
  );
}

//品德评语
function SearchComment(that) {
  that.fullscreenLoading = true;
  var param = JSON.parse(JSON.stringify(that.data));
  ajaxGet(that, "/api/admin/workload/commentsearch", param, function (resData) {
    that.fullscreenLoading = false;
    that.itemComment = resData;
  });
}
</script>

<style scoped="scoped" lang="less">
.echartsBox {
  border-right: 2px dashed #efefef;
}

.tabsHeader {
  margin: -18px -20px;
  background-color: #f5f7fa;
  position: relative;

  .divSemesterBox {
    position: absolute;
    right: 6px;
    top: 6px;

    .spTitle {
      font-size: 14px;
    }
  }
}

.award {
  .awardImg {
    width: 90%;
    margin: 0px auto;
    padding-top: 15px;
  }

  .awardName {
    background-color: #8fb8ff;
    text-align: center;
    padding: 2px 5px;
    color: #ffffff;
    width: 90%;
    margin: 0px auto;
  }

  .awardType {
    text-align: center;
    color: #b0b5c9;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .awardTime {
    padding-bottom: 15px;
    color: #414b62;
    text-align: center;
  }
}

.box-card {
  margin: 0;
}

.commentLevel1 {
  color: #f8ad3a !important;
}

.commentLevel2 {
  color: #3ddc18 !important;
}

.commentLevel3 {
  color: #ff3368 !important;
}

.commentLevel4 {
  color: #acb2c6 !important;
}

.commentLevel .icon {
  font-size: 32px;
}

.pageBox {
  .commentHeader {
    padding-bottom: 10px;

    .leftBox {
      float: left;
      font-size: 24px;
    }

    .rightBox {
      float: right;
      padding-top: 5px;
    }
  }

  .commentList {
    background-color: #f8f9ff;
    padding: 20px;
    border-radius: 10px;
    margin-top: 15px;
    margin-bottom: 15px;

    .semesterName {
      font-size: 22px;
      color: #0b1d59;
    }

    .levelBox {
      font-weight: bold;
      font-size: 22px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .teacherBox {
      position: relative;
      height: 30px;

      .teacherImage {
        position: absolute;
        left: 0;
        top: 0;
        width: 50px;
        height: 70px;
      }

      .maleBox {
        background-color: #23a3f8;
      }

      .femaleBox {
        background-color: #ffb7c2;
      }

      .teacherName {
        font-size: 18px;
        color: #0b1d59;
        padding-top: 10px;
      }

      .commentTime {
        color: #8ea5c0;
        padding-top: 2px;
      }
    }

    .commentFont {
      padding-top: 15px;
      color: #0b1d59;
    }
  }

  .listHeader {
    padding: 10px;

    .leftBox {
      float: left;
      font-size: 32px;
      padding-left: 10px;
    }

    .rightBox {
      float: right;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 15px;
    }
  }

  .listBox {
    padding: 0;

    .schoolYearBox {
      display: none;
    }
  }

  .schoolYear {
    position: relative;

    .schoolYearBox {
      position: absolute;
      display: inline-block;
      background-color: #307bff;
      color: #ffffff;
      top: 0;
      left: 0;
      height: 30px;
      line-height: 30px;
      padding-left: 15px;
      padding-right: 15px;
      border-radius: 4px 0px 0px 0px;
    }
  }
}

.pageBox .schoolYear .tableFiles th {
  padding-top: 40px;
}

.tableFiles {
  width: 100%;
}

.tableFiles th {
  background-color: #eaefff;
  font-weight: normal;
  color: #323d56;
  padding: 15px;
  font-size: 18px;
}

.tableFiles td {
  color: #323d56;
  font-weight: normal;
  height: 50px;
  padding: 0px 15px;
}

.tableFiles tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.pageBox .listBox .spLevel {
  background-color: #f8f9fa;
  font-size: 14px;
  padding: 2px;
  margin-right: 5px;
}

.pageBox .imgListBox {
  height: 50px;
  position: relative;
  width: 99.9%;
  overflow: hidden;
  padding-left: 35px;
  padding-right: 35px;
}

.pageBox .singleImageBox {
  padding-left: 15px;
  padding-right: 15px;
  width: 80px;
}

.pageBox .imgListBox .aLink {
  position: absolute;
  font-size: 32px;
  top: 8px;
  bottom: 0;
}

.pageBox .imgListBox .aLeftOperation {
  float: left;
  left: 0;
  width: 30px;
}

.pageBox .imgListBox .aRightOperation {
  float: right;
  right: 0;
  width: 30px;
}

.pageBox .imgListBox .imgContent {
  position: absolute;
  left: 30px;
  right: 30px;
  top: 0;
  bottom: 0;
  white-space: nowrap;
  overflow: hidden;
}

.pageBox .imgListBox .imgContent .imgBox {
  height: 50px;
  width: 1000px;
}

.pageBox .imgListBox .imgContent .spImg {
  float: left;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #eeeeee;
  margin: 5px;
}

.pageBox .imgListBox .imgContent .spImg .itemImg {
  width: 150%;
}

.pageBox .singleImageBox .imgContent {
  left: 0;
  right: 0;
}

.pageFooter {
  padding: 10px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.03);
  height: 50px;
}

.pageBox .cardTypeLable {
  border: 2px solid #ffffff;
}

.pageBox .cardTypeAct,
.pageBox .cardTypeLable:hover {
  cursor: pointer;
  border: 2px solid #3364ff;
}

.pageBox .studentInfoBox {
  background-color: #ffffff;
  padding: 20px 30px;
  border-radius: 10px;
  position: relative;
}

.pageBox .studentInfoBox .studentName {
  font-size: 32px;
  color: #323d56;
  display: flex;

  .spLabelList {
    margin-top: 7px;
    margin-left: 15px;
    margin-right: 15px;
    font-size: 16px;
  }
}

.pageBox .studentInfoBox .studentLabel {
  padding-top: 10px;
  padding-bottom: 10px;
}

.pageBox .studentInfoBox .studentLabel .spLabel {
  border-right: 2px solid #e4e4e4;
  padding-left: 30px;
  padding-right: 30px;
  color: #323d56;
  white-space: nowrap;
  /*强制span不换行*/
  letter-spacing: 1px;
}

.pageBox .studentInfoBox .studentLabel .spLabel:first-child {
  padding-left: 0;
}

.pageBox .studentInfoBox .studentLabel .spLabel:last-child {
  padding-right: 0;
  border-right: none;
}

.pageBox .studentInfoBox .studentImageBox {
  position: absolute;
  top: 30px;
  right: 40px;
  width: 100px;
  height: 140px;
}

.pageBox .studentInfoBox .studentImageBox .studentGender {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 30px;
  height: 30px;
  background-color: #1298fc;
  color: #ffffff;
  border-radius: 50%;
}

.pageBox .studentInfoBox .studentImageBox .genderFemale {
  background-color: #ff3ec9;
}

.pageBox .studentInfoBox .studentImageBox img {
  width: 100px;
  height: 140px;
  border-radius: 4px;
  border: 1px solid #eeeeee;
}

.pageBox .typeLabelBox {
  height: 80px;
}

.pageBox .typeLabelBox .rightBox,
.pageBox .typeLabelBox .leftBox {
  float: left;
}

.pageBox .typeLabelBox .leftBox {
  text-align: center;
  width: 100px;
  height: 80px;
}

.pageBox .typeLabelBox .iconBox {
  background-color: #eeeeee;
  color: #000000;
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.pageBox .typeLabelBox .iconBox .icon {
  font-size: 34px;
}

.pageBox .typeLabelBox .numberBox {
  color: #323d56;
  font-family: "OswaldLight";
  font-size: 34px;
  letter-spacing: 1px;
  font-weight: bold;
}

.pageBox .typeLabelBox .numberBox .spUnit {
  font-size: 18px;
  padding-left: 5px;
}

.pageBox .typeLabelBox .typeName {
  color: #acb2c6;
  letter-spacing: 1px;
}

.pageBox .typeLabelBox .labelColor_1 {
  background-color: #e5fbfa;
  color: #17dccd;
}

.pageBox .typeLabelBox .labelColor_2 {
  background-color: #eaefff;
  color: #3364ff;
}

.pageBox .typeLabelBox .labelColor_3 {
  background-color: #fff5f8;
  color: #ffa1c0;
}

.pageBox .typeLabelBox .labelColor_4 {
  background-color: #fff8eb;
  color: #ffbc20;
}

.pageBox .typeLabelBox .labelColor_5 {
  background-color: #e9fbe5;
  color: #3ddc18;
}

.pageBox .typeLabelBox .labelColor_6 {
  background-color: #ffeaf4;
  color: #ff3368;
}

.pageBox .typeLabelBox .labelColor_7 {
  background-color: #eafffe;
  color: #33c1ff;
}

.divPageHeaderBox {
  display: flex;
  padding-bottom: 5px;
}

.divPageHeaderBox .ulTabsBox {
  flex: 1;
  display: flex;
  padding-top: 10px;
}

.divPageHeaderBox .liTab {
  padding-left: 15px;
  padding-right: 15px;
  font-size: 18px;
  border-right: 2px solid #cecece;
  color: #767676;
  cursor: pointer;
}

.divPageHeaderBox .liTab:hover {
  color: #3e3e3c;
}

.divPageHeaderBox .liTab:last-child {
  border-right: none;
}

.divPageHeaderBox .liAction:hover,
.divPageHeaderBox .liAction {
  color: #3364ff;
}

.divPageHeaderBox .divSemesterBox {
  display: flex;
}

.divPageHeaderBox .divSemesterBox .divTitle {
  height: 40px;
  line-height: 40px;
  letter-spacing: 2px;
  color: #323e56;
  padding-right: 10px;
}
</style>

<style scoped="scoped">
@media screen and (max-width: 1440px) {
}
</style>
<style lang="less">
.tabsHeader {
  .el-tabs__header {
    margin: 0;
    margin-bottom: -1px;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background-color: #ffffff;
  }
}

.pageBox .commentHeader .selDivForm .el-input__inner {
  border: 1px solid #307bff;
  height: 30px;
  border-radius: 30px;
  color: #307bff;
}

.pageBox .commentHeader .selDivForm .el-input__icon {
  line-height: 25px;
}

.pageBox .commentHeader .selDivForm .el-select__caret {
  color: #307bff;
}

.schoolYearBox {
  background: skyblue;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
}
</style>
